import script from "./addon.vue?vue&type=script&lang=jsx"
export * from "./addon.vue?vue&type=script&lang=jsx"

import "./addon.vue?vue&type=style&index=0&id=9068c110&lang=scss"

const __exports__ = script;

export default __exports__